/*! @pentacode/ui v0.1.0 */
import { t as e } from "./decorateMetadata-BhwOl-pv.js";
import { t } from "./decorate-DHgd5sZx.js";
import { t as n } from "./css-build-DICbZE45.js";
import { t as r } from "./tooltip-2tBgcqiB.js";
import { customElement as i } from "lit/decorators.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/pointer-tooltip/pointer-tooltip.css.js
var a = n(".tooltip::part(popup){pointer-events:none}"), o = ["pointermove", "dragover"], s = class extends r {
	static get styles() {
		return [super.styles, a];
	}
	constructor() {
		super(), this._x = 0, this._y = 0, this._virtualAnchor = { getBoundingClientRect: () => new DOMRect(this._x, this._y, 0, 0) }, this._track = (e) => {
			this._x = e.clientX, this._y = e.clientY, this.open && this.popup?.reposition();
		}, this.trigger = "manual", this.placement = "top-start", this.distance = 8, this.skidding = 0, this.withoutArrow = !0;
	}
	updated(e) {
		super.updated(e), this.popup.anchor !== this._virtualAnchor && (this.popup.anchor = this._virtualAnchor, this.popup.hoverBridge = !1);
	}
	connectedCallback() {
		super.connectedCallback();
		for (let e of o) window.addEventListener(e, this._track, {
			capture: !0,
			passive: !0
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback();
		for (let e of o) window.removeEventListener(e, this._track, { capture: !0 });
	}
};
s = t([i("ptc-ui-pointer-tooltip"), e("design:paramtypes", [])], s);
var c = s;
//#endregion
export { c as n, s as t };

//# sourceMappingURL=pointer-tooltip-CnEyNMRN.js.map